import { reducer as schedules } from "features/Schedules";
import { reducer as settings } from "features/Dealers/DealerOffice/Settings";

export default {
  settings,
  schedules,
};
